"use strict";
export var SearchTab = /* @__PURE__ */ ((SearchTab2) => {
  SearchTab2["All"] = "All";
  SearchTab2["Tokens"] = "Tokens";
  SearchTab2["Pools"] = "Pools";
  SearchTab2["Wallets"] = "Wallets";
  SearchTab2["NFTCollections"] = "NFTs";
  return SearchTab2;
})(SearchTab || {});
export const WEB_SEARCH_TABS = ["All" /* All */, "Tokens" /* Tokens */, "Pools" /* Pools */];
export const MOBILE_SEARCH_TABS = ["All" /* All */, "Tokens" /* Tokens */, "Wallets" /* Wallets */, "NFTs" /* NFTCollections */];
